import { ReactElement, SVGProps } from 'react';
import { ReactComponent as UsaIconComponent } from './usa-icon.svg';

export const UsaIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <UsaIconComponent {...props} />;
};
